module.exports = __webpack_public_path__ + "img/PCT08.5e6fd283.svg";